import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/tailwindcss.css";

Vue.config.productionTip = false;
import "vant/lib/index.css";
//弹出面板ActionSheet
import { ActionSheet } from "vant";
Vue.use(ActionSheet);
//van-cell
import { Cell } from "vant";
Vue.use(Cell);
//Notify
import { Notify } from "vant";
// 全局注册
Vue.use(Notify);
//CountDown
import { CountDown } from "vant";
Vue.use(CountDown);
import { Overlay } from "vant";

Vue.use(Overlay);
import { Dialog } from "vant";
Vue.use(Dialog);

//progress
import { Progress } from "vant";
Vue.use(Progress);
import loading from "@/components/loading/loading";
Vue.prototype.$loading = loading;
import i18n from "./plugins"; // internationalization
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
